import { defineStore } from "pinia";

export interface SearchStoreState {
    history: string[];
}

export const useSearchHistory = defineStore("SearchHistory", {
    state: (): SearchStoreState => ({
        history: [],
    }),
    actions: {
        saveHistoryToStorage() {
            localStorage.setItem("search_history", JSON.stringify(this.history));
        },
        saveHistoryItem(item: string) {
            if (!this.history.includes(item)) {
                this.history.unshift(item);
            }
            this.saveHistoryToStorage();
        },
        getHistory() {
            const saved = localStorage.getItem("search_history");
            if (saved) {
                this.history = JSON.parse(saved);
            } else {
                this.history = [];
            }
        },
        clearHistoryItem(item: string) {
            this.history = this.history.filter((i) => i !== item);
            this.saveHistoryToStorage();
        },
        clearAllHistory() {
            this.history = [];
            this.saveHistoryToStorage();
        },
    },
});
